'use client';
import React, { useState } from 'react';
import styles from './checklist.module.sass';
import cn from 'classnames';
import { FontIcon } from '../FontIcon';
import { useMediaQuery } from '@intigral/hooks/dom/useMediaQuery/useMediaQuery';

export interface List {
    text: string | React.ReactNode;
    disabled?: boolean;
    value?: string | React.ReactNode;
    unsupported?: boolean;
    children?: string[];
    onClick?: () => void;
}

interface CheckListProps extends React.HTMLAttributes<HTMLDListElement> {
    items: List[];
    border?: boolean;
    compareMode?: boolean;
    noIcon?: boolean;
    equal?: boolean;
}

// Helper function to reuse Children
const renderChildren = (children?: string[]) => {
    return children ? (
        <ul className={styles.ul}>
            {children.map((nested, index) => (
                <li key={index}>{nested}</li>
            ))}
        </ul>
    ) : null;
};

export const CheckList = ({ items, border, compareMode, noIcon, equal, className, ...props }: CheckListProps) => {
    const isMobile = useMediaQuery('(max-width: 924px)');

    const classes = cn(
        styles.list,
        border && styles.border,
        compareMode && styles.compare,
        equal && styles.equal,
        className
    );

    return (
        <dl className={classes} {...props}>
            {(items || []).map((item, index) => (
                <React.Fragment key={`item-${index}-${typeof item.text === 'string' ? item.text : index}`}>
                    <dt
                        className={cn({ [styles.disabled]: item.disabled, [styles.nested]: item.children })}
                        onClick={item.onClick}
                    >
                        {!isMobile &&
                            !noIcon &&
                            (item.disabled ? (
                                <FontIcon name="close" md="smaller" />
                            ) : (
                                <FontIcon name="check-green" md="smaller" color="green" />
                            ))}

                        {isMobile &&
                            !compareMode &&
                            !item.value &&
                            (item.disabled ? (
                                <FontIcon name="close" md="smaller" />
                            ) : (
                                <FontIcon name="check-green" md="smaller" color="green" />
                            ))}

                        {item.text}

                        {!isMobile && renderChildren(item.children)}
                    </dt>

                    {/* The logic of this part:
                    For PC we show value, if it is there, and an empty space otherwise.
                    For mobile we show equivalent symbol if no value was provided  */}
                    {/* {isMobile &&
                        compareMode &&
                        (!item.children ? (
                            item.disabled ? (
                                <dd className={styles.disabled}>
                                    <FontIcon name="close" md="smaller" />
                                </dd>
                            ) : (
                                <dd>
                                    <FontIcon name="check-green" md="smaller" color="green" />
                                </dd>
                            )
                        ) : (
                            <dd>{renderChildren(item.children)}</dd>
                        ))} */}
                    {!item.children && (
                        <dd>
                            {item.value !== 'X' ? item.value : <FontIcon name="close" md="smaller" color="gray" />}
                        </dd>
                    )}

                    {/* {!isMobile && compareMode && !item.children && <dd>{item.value}</dd>} */}
                </React.Fragment>
            ))}
        </dl>
    );
};
